"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AccordionSummary_1 = __importDefault(require("atomicComponents/atoms/Accordion/AccordionSummary"));
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
exports.default = (0, DefaultPropsHoC_1.default)(AccordionSummary_1.default, {
    iconColor: 'pink',
    disableGutters: true,
});
